<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
          optionValue="value" placeholder="Status"></p-dropdown>
          <label for="Status">Status</label>
          <span *ngFor="let validation of validationMessages.status">
            <small class="p-invalid"
              *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="actType" id="actType" type="number" pInputText>
          <label for="actType">Act Type</label>
          @for (validation of validationMessages.actType; track validation) {
            <span>
              @if (form1.get('actType').hasError(validation.type) && (form1.get('actType').dirty || form1.get('actType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="actCode" id="actCode" type="text" pInputText>
          <label for="actCode">Act Code</label>
          @for (validation of validationMessages.actCode; track validation) {
            <span>
              @if (form1.get('actCode').hasError(validation.type) && (form1.get('actCode').dirty || form1.get('actCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="actName" id="actName" type="text" pInputText>
          <label for="actName">Act Name</label>
          @for (validation of validationMessages.actName; track validation) {
            <span>
              @if (form1.get('actName').hasError(validation.type) && (form1.get('actName').dirty || form1.get('actName').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <textarea formControlName="description" id="description" [rows]="2" pInputTextarea></textarea>
          <label for="description">Description</label>
          @for (validation of validationMessages.description; track validation) {
            <span>
              @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!-- <div class="col-lg-12">
      <span class="p-float-label w-100 mb-3">
        <p-calendar formControlName="chartAccountDate" inputId="chartAccountDate" appendTo="body">
        </p-calendar>
        <label for="chartAccountDate">ChartAccount Date</label>
        <span *ngFor="let validation of validationMessages.chartAccountDate">
          <small class="p-invalid"
            *ngIf="form1.get('chartAccountDate').hasError(validation.type) && (form1.get('chartAccountDate').dirty || form1.get('chartAccountDate').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->

    <!-- <div class="col-lg-12">
    <h6 for="isChartAccount">ChartAccount Options</h6>
    <div class="flex align-items-center">
      <p-checkbox [formControl]="form1.controls['isChartAccount']" inputId="isChartAccount" [binary]="true"></p-checkbox>
      <span class="chartAccount-nm">Is ChartAccount?</span>
    </div>
    <span *ngFor="let validation of validationMessages.isChartAccount">
      <small class="p-invalid"
        *ngIf="form1.get('isChartAccount').hasError(validation.type) && (form1.get('isChartAccount').dirty || form1.get('isChartAccount').touched)">{{validation.message}}
      </small>
    </span>
  </div> -->

</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (chartAccountId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete ChartAccount</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!chartAccountId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add ChartAccount</button>
          }

          @if (chartAccountId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update ChartAccount</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>